/**
 * Captures and restores the local transforms of the objects a driver's clips move, so every driver
 * (AnimationPlayer, GLB per ADR-0014, AnimationTree per ADR-0019) restores the authored pose on stop.
 */
/** Every object in `root`'s subtree: a skeletal or blended glTF clip may touch any bone. */
export function subtreeObjects(root) {
    const objects = [];
    root.traverse((object) => objects.push(object));
    return objects;
}
/**
 * Snapshot each object's local transform. The Euler rotation too: it carries the order an
 * AnimationPlayer reorders its targets to, which the quaternion does not.
 */
export function snapshotPose(objects) {
    return objects.map((object) => ({
        object,
        position: object.position.clone(),
        rotation: object.rotation.clone(),
        quaternion: object.quaternion.clone(),
        scale: object.scale.clone(),
    }));
}
export function restoreSnapshot(snapshots) {
    for (const snap of snapshots) {
        snap.object.position.copy(snap.position);
        snap.object.rotation.copy(snap.rotation);
        snap.object.quaternion.copy(snap.quaternion);
        snap.object.scale.copy(snap.scale);
    }
}
//# sourceMappingURL=poseSnapshot.js.map